var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("svg", {
    attrs: {
      width: "30",
      height: "30",
      viewBox: "0 0 120 120"
    }
  }, [_c("circle", {
    attrs: {
      cx: "60",
      cy: "60",
      r: "54",
      fill: "none",
      stroke: "#e6e6e6",
      "stroke-width": "12"
    }
  }), _c("circle", {
    staticClass: "percent fifty",
    style: {
      "stroke-dashoffset": "calc(100 - ".concat(_vm.percent, ")")
    },
    attrs: {
      cx: "60",
      cy: "60",
      r: "54",
      fill: "none",
      stroke: "#3b82f6",
      "stroke-width": "12",
      pathLength: "100"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };